// 优惠相关 getters
import calc from 'calculatorjs'

export const getters = {
  // brand-fence:start id=shared-store-discount-edition-rates brand=data-driven predicate=data-driven
  discountSrList (state, getters, rootState) {
    const prepareModel = state.createPrepare
    if (getters.shippingRatesInfo.transport === 'se') {
      const srList = []
      if (prepareModel.parcelsInfo.isAllPclDG1688 === 1) {
        // 1688 包裹才有的優惠
        let sr = null
        if (getters.shippingRatesInfo.srLabel === 'HZKZQ') {
          sr = prepareModel.shippingRates.find(item => item.srLabel === 'ENT1688' && item.srTwAddrid === getters.shippingRatesInfo.srTwAddrid)
        } else {
          sr = prepareModel.shippingRates.find(item => item.srLabel === 'ENT1688' && String(item.srTwAddrid) === '0')
        }
        if (sr) {
          srList.push(sr)
        }
      }
      if (rootState.edition === 's') {
        srList.push(
          ...prepareModel.shippingRates
            .filter(item => item.srLabel === 'SHOPEE26' || item.srLabel === 'ENT28')
        )
      }
      return srList
    }
    return []
  },
  // brand-fence:end id=shared-store-discount-edition-rates
  // 最优惠的sr
  bestDiscountSr (state, getters) {
    const srList = getters.discountSrList
    let sr = srList[0]
    srList.forEach(item => {
      if (item.parcelsFeeFormulas.srFees[6] < sr.parcelsFeeFormulas.srFees[6]) {
        sr = item
      }
    })
    return sr
  },
  cneeAddressDiscount (state, getters) {
    const sr = getters.bestDiscountSr || getters.shippingRatesInfo
    if (sr.transport === 'se' && sr.parcelsFeeFormulas?.cneeAddressDiscount) {
      return sr.parcelsFeeFormulas.cneeAddressDiscount
    }
    return null
  },
  // 其他费用
  otherFees (state, getters, rootState) {
    const prepare = state.createPrepare
    const preTax = 0

    // 离岛費
    let landFee = 0
    if (state.currAddrInfo) {
      if (prepare?.parcelsInfo?.allItemInclFreight === 'Y') {
        landFee = 0
      } else if (getters.shippingRatesInfo.srLabel === 'HZKZQ') {
        landFee = 0
      } else if (prepare?.islands?.find(item => state.currAddrInfo.city.indexOf(item) > -1)) {
        landFee = prepare.islandFee
      }
    }
    let landFeeDiscount = 0
    if (landFee > 0 && prepare.parcelsInfo.jyAddrid === '3591') {
      landFeeDiscount = 100
    }

    return {
      preTax, // 稅金保證金
      landFee,
      landFeeDiscount,
      otherFee: calc(`${preTax} + ${landFee} - ${landFeeDiscount}`)
    }
  },
}
